import React from "react";
import { Route } from "react-router-dom";
import AggregatorDashboard from "../../screens/aggregator/AggregatorDashboard";
import FPOList from "../../screens/aggregator/FPOList";
import FpoFarmerList from "../../screens/aggregator/FpoFarmerList";
import Programs from "../../screens/programs/Programs";
import CreateProgram from "../../screens/programs/CreateProgram";
import EditProgram from "../../screens/programs/EditProgram";
import CreateProgramInput from "../../screens/programs/CreateProgramInput";
import UploadProgramInputs from "../../screens/programs/UploadProgramInputs";
import EditProgramInput from "../../screens/programs/EditProgramInput";
import CreateProgramInputTask from "../../screens/programs/CreateProgramInputTask";

export const fpoAggregatorRoutes = [
  <Route
    key="fpo-aggregator-fpo-list"
    path="/fpo-list"
    element={<FPOList />}
  />,
  <Route
    key="fpo-aggregator-home"
    path="/"
    element={<AggregatorDashboard />}
  />,
  <Route
    key="fpo-aggregator-fpo-farmer-list"
    path="/fpo-farmer-list/:fpoId"
    element={<FpoFarmerList />}
  />,
  <Route
    key="fpo-aggregator-programs"
    path="/programs"
    element={<Programs />}
  />,
  <Route
    key="fpo-aggregator-create-program"
    path="/programs/program/create"
    element={<CreateProgram />}
  />,
  <Route
    key="fpo-aggregator-edit-program"
    path="/programs/program/:programId"
    element={<EditProgram />}
  />,
  <Route
    key="fpo-aggregator-create-program-input"
    path="/programs/:programId/add-input"
    element={<CreateProgramInput />}
  />,
  <Route
    key="fpo-aggregator-upload-program-inputs"
    path="/programs/:programId/upload-inputs"
    element={<UploadProgramInputs />}
  />,
  <Route
    key="fpo-aggregator-edit-program-input"
    path="/programs/program-input/:programInputId"
    element={<EditProgramInput />}
  />,
  <Route
    key="fpo-aggregator-create-program-input-task"
    path="/programs/program-input/:programInputId/add-task"
    element={<CreateProgramInputTask />}
  />,
];
